<template>
   <!--Footer-->
    <footer id="footer" class="page-footer scrollspy">
        <div class="container">
            <div class="row">
                <div class="col l6 s12">
                    <ContactForm/>
                </div>
                <div class="col l3 s12">
                    <h5 class="white-text">Swarm.video</h5>
                    <ul>
                        <li><a class="white-text" href="https://swarm.video">login</a></li>
                        <li><a class="white-text" href="https://swarm.video">Register</a></li>
                    </ul>
                </div>
                <div class="col l3 s12">
                    <h5 class="white-text">Contact us</h5>
                    <ul>
                        <li>
                            <a class="white-text" href="skype:info_1093571?chat">
                                <i class="small fa fa-skype white-text"></i> info@swarm.video
                            </a>
                        </li>
                        <li>
                            <a class="white-text" href="mailto:info@swarm.video">
                                <i class="small fa fa-envelope white-text"></i> info@swarm.video
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-copyright default_color">
            <div class="container">
                ©2020 &nbsp  <a class="white-text" href="https://swarm.video"> SWARM.VIDEO </a>  &nbsp Made  &nbsp with 
                 &nbsp<span class="red-text">💪</span> &nbsp for  &nbsp distributed  &nbsp web.
            </div>
        </div>
    </footer>
</template>
<script>

import ContactForm from "../messages/ContactForm.vue";
export default {
components: {    
    ContactForm
  },

};
</script>
<style>
.footer-copyright .container{
    justify-content: right !important;
}
#footer  div  a {
    color: white;
}

</style>
